import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { searchLocations, searchLocationsSuccess } from './location.actions';
import { LocationService } from './location.service';
import { loadError } from '../error/error.action';
import { createActionError } from '../../models/action-error';
import { TadLocation } from 'src/generated/graphql';

@Injectable()
export class LocationEffects {
  constructor(private actions$: Actions, private locationService: LocationService) {}

  public getLocations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(searchLocations),
      switchMap(({ input }) =>
        this.locationService.getLocations(input).pipe(
          map((response) =>
            searchLocationsSuccess({
              locations: (response.data.searchLocations as TadLocation[]) || []
            })
          ),
          catchError((error) => {
            return of(loadError(createActionError(error.message ?? 'Get Locations Failed.')));
          })
        )
      )
    )
  );
}
